// extracted by mini-css-extract-plugin
export default {"initialsLarge":"Initials_initialsLarge__LJPD4","text":"Initials_text__ttBzx","initialsSmall":"Initials_initialsSmall__LDMh3"};